import select from '../../dom/modules/select.js';
select('form.cookie-site-block', document.body).forEach((form) => {
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        let data = new FormData();
        data.append('csrfmiddlewaretoken', document.querySelector('input[name="csrfmiddlewaretoken"]').getAttribute('value'));

        let url = form.getAttribute('action') + '?ajax';
        fetch(url, {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
        })
        .then(response => response.text())
        .then(d => console.log(d))
        .then(form.remove());
    })
});
